import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

/** The loader stays at least this long, so a quick page change doesn't make it blink. */
const MIN_VISIBLE_MS = 800;
/** Length of the fade-out (matches the transition in loader.component.scss). */
const FADE_MS = 300;

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  isLoading = false;
  isFading = false;

  private shownAt = 0;
  private hideTimer?: ReturnType<typeof setTimeout>;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // First visit on phones: show the page straight away instead of
        // covering it, so the mobile first paint (LCP / Speed Index) is not
        // delayed. Desktop and later page changes still show the loader.
        if (event.id === 1 && window.matchMedia('(max-width: 767px)').matches) return;
        clearTimeout(this.hideTimer);
        if (!this.isLoading) this.shownAt = Date.now();
        this.isLoading = true;
        this.isFading = false;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.hide();
      }
    });
  }

  // Wait out the minimum time, fade, then remove the loader
  private hide(): void {
    const wait = Math.max(0, MIN_VISIBLE_MS - (Date.now() - this.shownAt));
    this.hideTimer = setTimeout(() => {
      this.isFading = true;
      this.hideTimer = setTimeout(() => {
        this.isLoading = false;
        this.isFading = false;
      }, FADE_MS);
    }, wait);
  }
}
